import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import DeleteModal from "../../../core/modals/deleteModal";
import CommonSelect from "../../../core/common/commonSelect";

const statusChoose = [
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];
type Option = {
  value: string;
  label: string;
};

const Assign_Kra = () => {
  const [loading, setLoading] = useState(false);
  const [allItemList, setAllItemList] = useState<any[]>([]);
  const [newItem, setNewItem] = useState<any>({
    employee: "",
    kraName: "",
  });
  const [selectedItem, setSelectedItem] = useState<any>({});
  const [kraList, setKraList] = useState<any[]>([]);
  const [employeeList, setEmployeeList] = useState<any[]>([]);
  const [errors, setErrors] = useState<any>({});

  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());

  const options_employee: any[] = useMemo(
    () =>
      employeeList.map((item) => ({
        value: `${item.employee_id}`,
        label: `${item.employee_id} -  ${item.employee_name}`,
      })),
    [employeeList]
  );

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "SrNo",
      render: (text: string, record: any, index: number) => (
        <h6 className="fw-medium fs-14 text-dark">{index + 1}</h6>
      ),
      // sorter: (a: any, b: any) => a.SrNo - b.SrNo,
    },
    {
      title: "Employee",
      dataIndex: "employee",
      sorter: (a: any, b: any) => a.employee.localeCompare(b.employee),
    },
    {
      title: "KRA",
      dataIndex: "kraName",
      sorter: (a: any, b: any) => a.kraName.localeCompare(b.kraName),
    },
    {
      title: "Category",
      dataIndex: "category",
      sorter: (a: any, b: any) => a.category.localeCompare(b.category),
    },
    {
      title: "Weightage",
      dataIndex: "weightage",
      render: (text: string, record: any) => (
        <p className="text-center">{text} %</p>
      ),
      sorter: (a: any, b: any) => a.weightage - b.weightage,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string, record: any) => (
        <>
          <span
            className="bg-transparent d-flex"
            style={{ width: "max-content" }}
          >
            {text}
          </span>
          {/* <span className={`badge ${text === '1' ? 'badge-success' : 'badge-danger'} d-inline-flex align-items-center badge-xs`}>
                    <i className="ti ti-point-filled me-1" />
                    {text === "1" ? "Active" : "Inactive"}
                </span> */}
        </>
      ),
      // sorter: (a: any, b: any) => a.attachment.localeCompare(b.attachment),
      sorter: (a: any, b: any) => a.status.length - b.status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: any, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#edit_kragoal"
            onClick={() => {
              setSelectedItem(record);
            }}
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#delete_modal"
            onClick={() => {
              setSelectedItem(record);
            }}
          >
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];

  // const resetStates = () => {
  //     setNewItem({
  //         a: ""
  //     })
  // }

  const handleChange = <T extends Object>(
    setter: React.Dispatch<React.SetStateAction<T>>,
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    // console.log(name, value)
    setter((prev) => ({ ...prev, [name]: value }));
    setErrors((prev: any) => ({ ...prev, [name]: null }));
  };

  const handleSelect = (
    option: any,
    fieldName: string,
    setter: React.Dispatch<React.SetStateAction<any>>
  ) => {
    setter((prev: any) => ({
      ...prev,
      [fieldName]: option?.value ? String(option?.value) : "",
    }));
    setErrors((prev: any) => ({ ...prev, [fieldName]: null }));
  };

  const AddNewItem = async (e: any) => {
    e.preventDefault();
   
    setErrors({});

    try {
      // const resp = await AXIOSCONFIGMETHOD("post", webServiceUrl. , newItem)
      // // console.log(resp)
      // if (resp?.data?.success) {
      //     fetchData()
      //     resetStates()
      //     toast.success(resp?.data?.message)
      // }
    } catch (error) {
      console.error("Error while adding :", error);
    }
  };

  const UpdateItemData = async (e: any) => {
    e.preventDefault();
   
    setErrors({});

    try {
      // const resp = await AXIOSCONFIGMETHOD("put", webServiceUrl. , {
      // })
      // if (resp?.data?.success) {
      //     fetchData()
      //     toast.success(resp?.data?.message)
      // }
    } catch (error) {
      console.error("Error while updating :", error);
    }
  };

  const DeleteItem = async () => {
    try {
      // const resp = await AXIOSCONFIGMETHOD("delete", `${webServiceUrl?. }/${selectedItem?.ID}`)
      // if (resp?.data?.success) {
      //     fetchData()
      //     toast.success(resp?.data?.message)
      // }
    } catch (error) {
      console.error("Error while deleting :", error);
    }
  };
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Assign KRA to Employee</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All KRA
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
              <div className="input-icon w-120 position-relative mb-2">
                <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {(() => {
                    const today = new Date();
                    const currentYear =
                      today.getMonth() >= 3
                        ? today.getFullYear()
                        : today.getFullYear() - 1;

                    return Array.from({ length: 1 }, (_, i) => {
                      const year = currentYear - i;
                      const nextYearShort = String(year + 1).slice(-2);
                      const financialYear = `${year}-${nextYearShort}`;

                      return (
                        <option key={financialYear} value={financialYear}>
                          {financialYear}
                        </option>
                      );
                    });
                  })()}
                </select>
              </div>
              <div className="mb-2">
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#add_category"
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Assign KRA
                </Link>
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Assigned KRA List</h5>
            </div>
            <div className="card-body p-0">
        
                <Table
                  dataSource={allItemList}
                  columns={columns}
                  Selection={false}
                />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">
            © {new Date().getFullYear()} WeConnect. All rights reserved.
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      {/* Add Modal */}
      <div className="modal fade" id="add_category">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title text-capitalize">Assign KRA</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={AddNewItem}>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Employee<span className="text-danger">*</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={options_employee}
                        defaultValue={newItem?.employee}
                        onChange={(option) => {
                          handleSelect(option, "employee", setNewItem);
                        }}
                      />
                      {errors?.employee && (
                        <div className="text-danger p-1 pb-0">
                          {errors?.employee}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        KRA<span className="text-danger">*</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={kraList}
                        defaultValue={newItem?.kraName}
                        onChange={(option) => {
                          handleSelect(option, "kraName", setNewItem);
                        }}
                      />
                      {errors.kraName && (
                        <div className="text-danger p-1 pb-0">
                          {errors.kraName}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Assign KRA Goal
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      <div className="modal fade" id="edit_kragoal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title text-capitalize">Edit KRA</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={UpdateItemData}>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Employee Id<span className="text-danger">*</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={statusChoose}
                        onChange={(option) => {
                          handleSelect(option, "employee_id", setSelectedItem);
                        }}
                      />
                      {errors.employee_id && (
                        <div className="text-danger p-1 pb-0">
                          {errors.employee_id}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        KRA<span className="text-danger">*</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={statusChoose}
                        onChange={(option) => {
                          handleSelect(option, "kra", setSelectedItem);
                        }}
                      />
                      {errors.kra && (
                        <div className="text-danger p-1 pb-0">{errors.kra}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  // data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Assign_Kra;
